import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Checkbox, Space, Table } from 'antd'
import { get, map } from 'lodash'

import { UpdateDataText } from '../../../core/components/sections'
import { formatDateFromNow } from '../../../core/utils'

import {
  StyledPageActionButton,
  StyledPageActions,
  StyledPageHeader,
  StyledPageTitle,
} from '../../../common/components/styled'
import { APP_ROUTES, PERMISSIONS, ROLES } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'
import { listToCommaSeparated } from '../../../common/utils'

import { PermissionGuard } from '../../../account/components/sections'
import { useUsersQuery } from '../../hooks'
import { UsersTableActionColumn } from '../sections'

const UsersPage = () => {
  useDocumentTitle(APP_ROUTES.MISC.children.USERS.label)
  const { data, isLoading, latestEvent } = useUsersQuery()

  const tableColumns = useMemo(
    () => [
      {
        title: 'User ID',
        dataIndex: 'id',
      },
      {
        title: 'Name',
        dataIndex: 'name',
      },
      {
        title: 'Roles',
        dataIndex: 'roles',
        render: roles =>
          listToCommaSeparated(
            map(roles, ({ name }) => get(ROLES, `${name}.label`)),
          ),
      },
      {
        title: 'Cuisine Knowledge',
        dataIndex: 'cuisineTypes',
        render: cuisineTypes => listToCommaSeparated(map(cuisineTypes, 'name')),
      },
      {
        title: 'Known Languages',
        dataIndex: 'languages',
        render: languages => listToCommaSeparated(map(languages, 'name')),
      },
      {
        title: 'Email',
        dataIndex: 'email',
      },
      {
        title: 'Latest login',
        dataIndex: 'loginDate',
        render: date => date && formatDateFromNow(date),
      },
      {
        title: 'Enabled',
        dataIndex: 'isActive',
        render: isActive => <Checkbox checked={isActive} disabled />,
      },
      {
        align: 'right',
        render: user => <UsersTableActionColumn user={user} />,
      },
    ],
    [],
  )
  return (
    <>
      <StyledPageHeader>
        <StyledPageTitle>Users</StyledPageTitle>
        <StyledPageActions>
          <PermissionGuard permissions={PERMISSIONS.USER.CREATE}>
            <StyledPageActionButton>
              <Link
                to={APP_ROUTES.MISC.children.USERS.children.USER_CREATE.path}
              >
                Add user
              </Link>
            </StyledPageActionButton>
          </PermissionGuard>
          <Space>
            <UpdateDataText
              updatedAt={latestEvent?.createdAt}
              updatedBy={latestEvent?.createdBy?.name}
            />
          </Space>
        </StyledPageActions>
      </StyledPageHeader>

      <Table
        loading={isLoading}
        rowKey="id"
        columns={tableColumns}
        dataSource={data}
        pagination={false}
      />
    </>
  )
}

export default UsersPage
